import {select as d3select} from 'd3-selection';
import {extent as d3extent} from 'd3-array';
import * as geo from 'd3-geo';
import {geoRobinson} from 'd3-geo-projection';
import {scaleLinear} from 'd3-scale';

import Model from '../Model/Model';
import Dispatch from '../Dispatch/Dispatch';
import State from '../State/State';

import './Map.css';

var width = 600, height = 330;
var container = d3select('#world-map g.Map-map');

var projection = geoRobinson()
  .scale(110)
  .translate([width / 2, height / 2])
  .precision(.1);

var geoGenerator = geo.geoPath()
  .projection(projection);

var choroplethScale = scaleLinear().domain([0, 30000000]).range(['#ccc', '#111']);

var getChoroplethSeries = () => {
	switch(State.selectedSeries) {
	case 'cases':
		return 'Cases ETEC and Shigella';

	case 'deaths':
		return State.includeIndirectDeaths ? 'Direct and indirect deaths ETEC and Shigella' : 'Direct deaths ETEC and Shigella';

	case 'dalys':
		return State.includeStunting ? 'DALYs direct and stunting ETEC and Shigella' : 'DALYs direct ETEC and Shigella';

	default:
		return '';
	}
}

function getValue(country) {
	var series = getChoroplethSeries();
	var countryData = Model.dataLU[country];
	var value = +countryData[series];

	if(State.selectedSeries === 'dalys' && State.dalysByRate) {
		value = 100000 * value / countryData['Population (<5)'];
	}

	return value;
}

function onCountryMouseover(d) {
	var name = d.properties.name_long;
	State.set('highlightedCountry', Model.dataLU[name] === undefined ? null : name);
	State.set('hoveredCountry', Model.dataLU[name] === undefined ? null : name);
}

function onCountryMouseout(d) {
	State.set('highlightedCountry', null);
	State.set('hoveredCountry', null);
}

function onCountryMousemove(d) {
	Dispatch.dispatch.call('mapMousemove');
}

function updateScales() {
  var extent = d3extent(Model.data, d => getValue(d.Country));
  choroplethScale.domain(extent);
}

function updateHighlight() {
	container
		.selectAll('path')
		.classed('highlighted', d => d.properties.name_long === State.highlightedCountry);
}


export function init() {
	Dispatch.dispatch.on('mapBoundariesReady.Map', update);
	Dispatch.dispatch.on('dataReady.Map', update);
	Dispatch.dispatch.on('selectedSeriesUpdate.Map', update);
	Dispatch.dispatch.on('highlightedCountryUpdate.Map', updateHighlight);
	Dispatch.dispatch.on('includeIndirectDeathsUpdate.Map', update);
	Dispatch.dispatch.on('includeStuntingUpdate.Map', update);
	Dispatch.dispatch.on('dalysByRateUpdate.Map', update);
}

export function update() {
	// console.log('map update', Model.data);

	if(Model.worldJson === null)
		return;

  // console.log('about to update map with ', Model.worldJson);

  if(Model.data !== null)
  	updateScales();

	var u = container
		.selectAll('path')
		.data(Model.worldJson.features);

	u
		.enter()
		.append('path')
		.attr('d', geoGenerator)
		.style('display', d => d.properties.name_long === 'Antarctica' ? 'none' : 'inline')
		.on('mouseover', onCountryMouseover)
		.on('mouseout', onCountryMouseout)
		.on('mousemove', onCountryMousemove)

		.merge(u)
		.style('fill', (d) => {
			var country = d.properties.name_long;
			if(Model.dataLU === null)
				return '#f0f0f0';

			if(Model.dataLU[country] === undefined)
				return '#f0f0f0';

			return choroplethScale(getValue(country));
		})
};


/** WEBPACK FOOTER **
 ** ./src/Map/Map.js
 **/